import * as Services from "../../Service/Service";
import * as Url from "../../Service/Url";

export const InsertClinicalIntakeData = async (payload) => {
  const token = localStorage.getItem("token");
  let res = await Services.POST(
    Url.INSERT_CLINICAL_INTAKE_DATA,
    payload,
    token
  );
  return res;
};

export const GetICD10NCDCodeAndDescription = async (
  pageSize,
  pageNum,
  searchTxt
) => {
  const token = localStorage.getItem("token");
  let res = await Services.GET(
    Url.GET_ICD10NDC_CODE_AND_DESCRIPTION +
      `pageSize=${pageSize}&pageNumber=${pageNum}&search=${searchTxt}`,
    token
  );
  return res;
};

export const GetCGTMemberID = async (pageSize, pageNum, searchTxt) => {
  const token = localStorage.getItem("token");
  let res = await Services.GET(
    Url.GET_CGT_MEMBER_ID +
      `pageSize=${pageSize}&pageNumber=${pageNum}&search=${searchTxt}`,
    token
  );
  return res;
};
export const GetCGTMemberIDs = async (pageSize, pageNum, searchTxt) => {
  const token = localStorage.getItem("token");
  let res = await Services.GET(
    Url.GET_CGT_MEMBER_IDS +
      `pageSize=${pageSize}&pageNumber=${pageNum}&search=${searchTxt}`,
    token
  );
  return res;
};
export const GetCGTMembers = async (id) => {
  const token = localStorage.getItem("token");
  let res = await Services.GET(
    Url.GET_CGT_MEMBER_ID_FORM +`=${id}`,token
  );
  return res;
};

export const GetStates = async () => {
  const token = localStorage.getItem("token");
  let res = await Services.GET(Url.GET_STATES, token);
  return res;
};

export const GetClientByCGTMemberID = async (CGTMemberID) => {
  const token = localStorage.getItem("token");
  let res = await Services.GET(
    Url.GETCLIENTBYCGTMEMBERID +`CGTMemberID=${CGTMemberID}`,token
  );
  return res;
}